export default "__VITE_ASSET__DGY4ftJR__"